import React from "react";

function Title(props) {
  return (
    <div >
      <h2 className="thepopcorn-title">{props.title}</h2>
    </div>
  );
}

export default Title;
